const whatsappUrl = "https://wa.me/qr/B5BVPSPSXGEBM1";

export default function Sobre() {
  return (
    <section id="sobre" className="py-14 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl md:rounded-3xl overflow-hidden h-[260px] lg:h-[480px]">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20flooring%20installation%20team%20working%20in%20modern%20apartment%2C%20vinyl%20plank%20flooring%20being%20installed%2C%20clean%20workspace%2C%20professional%20workers%20in%20uniform%2C%20Brazilian%20interior%2C%20ultra%20realistic%20photography&width=700&height=900&seq=sobre001&orientation=portrait"
                alt="Equipe Vynora Pisos"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge - visible on all sizes */}
            <div className="absolute -bottom-4 right-4 bg-amber-700 text-white rounded-xl p-4">
              <p className="text-2xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>4+</p>
              <p className="text-xs text-amber-200 mt-0.5">Anos de experiência</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="inline-block text-amber-700 text-xs font-bold tracking-widest uppercase mb-3">Quem somos</span>
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-stone-800 mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Qualidade premium<br />direto da fábrica
            </h2>
            <div className="w-12 h-0.5 bg-amber-600 mb-6" />
            <p className="text-stone-600 text-sm md:text-lg leading-relaxed mb-4">
              A <strong className="text-stone-800">Vynora Pisos</strong> oferece soluções em pisos vinílicos de alta qualidade, direto da fábrica, garantindo o melhor custo-benefício.
            </p>
            <p className="text-stone-600 text-sm md:text-lg leading-relaxed mb-8">
              Transformamos ambientes com sofisticação, rapidez e sem dor de cabeça. Nossa missão é levar o visual premium que você sempre sonhou para o seu lar, com preço justo e instalação impecável.
            </p>

            {/* Mini stats */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {[
                { num: "500+", label: "Projetos" },
                { num: "98%", label: "Satisfação" },
              ].map((s) => (
                <div key={s.label} className="text-center border-r border-stone-100 last:border-0">
                  <p className="text-xl md:text-2xl font-bold text-amber-700" style={{ fontFamily: "'Playfair Display', serif" }}>{s.num}</p>
                  <p className="text-stone-400 text-xs mt-1">{s.label}</p>
                </div>
              ))}
            </div>

            <a
              href="https://wa.me/11937354692?text=Ol%C3%A1%2C%20quero%20transformar%20meu%20ambiente"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-stone-800 hover:bg-stone-700 text-white font-semibold text-sm px-7 py-3.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-right-circle-line text-base" />
              Quero transformar meu ambiente
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}